<template lang="pug">
  .SampleGeographicDetails#SampleGeographicDetails
    .SampleGeographicDetails_content
      ParagraphList(:items="paragraphs")

</template>

<script>

import ParagraphList from '@/components/ParagraphList'

export default {
  props: ['geologicType'],
  components: {
    ParagraphList
  },
  data () {
    return {}
  },
  computed: {
    paragraphs () {
      let p = []
      if (Array.isArray(this.geologicType)) {
        let a = this.geologicType.find((g) => g.paragraphs != null)
        if (Array.isArray(a)) {
          for (let i = 0; i < a.length; i++) {
            p = p.concat(a[i].paragraphs)
          }
        } else { p = a.paragraphs }
      } else {
        p = this.geologicType.paragraphs
      }
      return p
    }
  }
}

</script>

<style lang="stylus" scoped>
.SampleGeographicDetails

  background-color $beige

</style>
